import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  InputAdornment,
  OutlinedInput,
  Radio,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { colorsEnums } from '../constants/enums';

export default function RadioSelect({
  name = '',
  value = '',
  dropdownValues = [],
  setFieldValue = () => { },
  required = false,
  label = '',
  helperText = '',
  multiple = false,
  hide = false,
  enableCustom = false,
  isCustomLockIN = false
}) {
  const [showCustomInput, setShowCustomInput] = useState(false)
  const [year, setYear] = useState()
  const [month, setMonth] = useState()

  // Helper function to compare values case-insensitively with partial matching
  // Handles cases like "Rented" matching "Rented / Leased"
  const isEqualCaseInsensitive = (val1, val2) => {
    if (!val1 || !val2) return false;
    const str1 = String(val1).toLowerCase().trim();
    const str2 = String(val2).toLowerCase().trim();
    // Handle for "rented / leased" case
    if (str2 === "rented / leased") {
      return str2.startsWith(str1);
    } else {
      return str1 === str2;
    }
  };

  // Helper function to check if array includes value case-insensitively
  // Uses isEqualCaseInsensitive() for each item comparison
  const includesCaseInsensitive = (arr, searchValue) => {
    return Array.isArray(arr) && arr.some(item => isEqualCaseInsensitive(item, searchValue));
  };

  useEffect(() => {
    if (isCustomLockIN) {
      setShowCustomInput(true)
      const yearMatch = value.match(/(\d+)\s*Year/i);
      const monthMatch = value.match(/(\d+)\s*Month/i);

      const year = yearMatch ? parseInt(yearMatch[1], 10) : 0;
      const month = monthMatch ? parseInt(monthMatch[1], 10) : 0;

      setYear(year)
      setMonth(month)
    }
  }, [])

  if (hide) {
    return null;
  }

  return (
    <FormControl sx={{ width: '100%', marginBottom: '.5rem' }}>
      <FormLabel sx={{ margin: '12px 0' }}>
        {label}{' '}
        {required && <span style={{ color: colorsEnums.error }}>*</span>}
      </FormLabel>
      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
        {dropdownValues?.map((item) => (
          <FormControlLabel
            key={item.id}
            sx={{
              '& .MuiButtonBase-root': {
                display: 'none !important',
              },
              border: '1px solid #600DB4',
              borderRadius: '8px',
              margin: '0rem 1rem 1rem 0 !important',
              padding: '6px 1rem',
              background:
                multiple && includesCaseInsensitive(value, item.value)
                  ? '#F5EDFF'
                  : !multiple && isEqualCaseInsensitive(value, item.value)
                    ? '#F5EDFF'
                    : '#fff',
              color: '#474747',
              textTransform: 'capitalize',
              fontSize: { lg: '16px', xs: '14px' },
              fontFamily: 'Inter',
            }}
            control={
              multiple ? (
                <Checkbox
                  checked={includesCaseInsensitive(value, item.value)}
                  onChange={() => {
                    const isChecked = includesCaseInsensitive(value, item.value);
                    if (isChecked) {
                      if (name === 'areasOfOperation') {
                        setFieldValue(item.value);
                      } else {
                        // Remove the matching value (case-insensitive) and keep the original casing from dropdown
                        setFieldValue(
                          name,
                          value?.filter((el) => !isEqualCaseInsensitive(el, item.value))
                        );
                      }
                    } else {
                      if (name === 'areasOfOperation') {
                        setFieldValue(item.value);
                      } else {
                        // Use the original casing from dropdownValues
                        setFieldValue(name, [...value, item.value]);
                      }
                    }
                  }}
                />
              ) : (
                <Radio
                  checked={isEqualCaseInsensitive(value, item.value)}
                  onChange={() => {
                    setFieldValue(name, item.value)
                    setShowCustomInput(false)
                    setYear()
                    setMonth()
                  }}
                />
              )
            }
            label={item.value}
          />
        ))}
        {enableCustom && <Button color="secondary" sx={{
          margin: '0rem 1rem 1rem 0 !important'
        }} size='small' onClick={() => {
          setShowCustomInput(true)
          setFieldValue(name, '')
          setFieldValue('isCustomLockIN', true)
        }}>

          Add custom</Button>}
      </Box>
      {(showCustomInput) &&
        <Box>
          <OutlinedInput
            sx={{ width: '30%', mr: 2 }}
            type='number'
            endAdornment={<InputAdornment position="end">Years</InputAdornment>}
            value={year}
            onChange={(e) => {
              if (e.target.value < 51) {
                setYear(e.target.value)
                setFieldValue(name, `${e.target.value > 0 ? e.target.value == 1 ? e.target.value + ' Year ' : e.target.value + ' Years ' : ''}${month > 0 ? month == 1 ? month + ' Month' : month + ' Months' : ''}`)
              }
            }}
            inputProps={{
              min: 0,
              style: { MozAppearance: 'textfield' },
            }}
          />
          <OutlinedInput
            sx={{ width: '30%' }}
            type='number'
            value={month}
            onChange={(e) => {
              if (e.target.value < 13) {
                setMonth(e.target.value)
                setFieldValue(name, `${year > 0 ? year == 1 ? year + ' Year ' : year + ' Years ' : ''}${e.target.value > 0 ? e.target.value == 1 ? e.target.value + ' Month' : e.target.value + ' Months' : ''}`)
              }
            }
            }
            inputProps={{
              min: 0,
              style: { MozAppearance: 'textfield' },
            }}
            endAdornment={<InputAdornment position="end">Months</InputAdornment>}
          />
        </Box>}

      {helperText && (
        <FormHelperText sx={{ color: '#bf3333' }}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
